import { Injectable } from '@angular/core';

import { PersonalInformation, VueAccountManagementService, VueSessionCookieService } from '@vue/vueframework';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PersonalInformationResolve {
  public constructor(
    private vueAccountManagementService: VueAccountManagementService,
    private vueSessionCookieService: VueSessionCookieService
  ) { }

  public resolve(): Observable<PersonalInformation> {
    const userId = this.vueSessionCookieService.getAttribute('appUserId');
    return this.vueAccountManagementService.getPersonalAndAddressInfo(userId)
      .pipe(
        catchError(() => {
          return of(null);
        })
      );
  }
}
